import type { PublicConfig } from "./types";

export function getPublicConfig(): PublicConfig {
  const defaults: PublicConfig = {
    adsEnabled: false,
    gaMeasurementId: "",
    indexable: false,
    tiktokEnabled: import.meta.env.VITE_TIKTOK_ENABLED === "true",
    tiktokIndexable: false,
    douyinEnabled: import.meta.env.VITE_DOUYIN_ENABLED === "true",
    douyinIndexable: false,
    xEnabled: import.meta.env.VITE_X_ENABLED === "true",
    xIndexable: false,
    bilibiliEnabled: import.meta.env.VITE_BILIBILI_ENABLED === "true",
    bilibiliIndexable: false
  };
  if (typeof window !== "undefined" && window.__PUBLIC_CONFIG__) {
    return { ...defaults, ...window.__PUBLIC_CONFIG__ };
  }
  return defaults;
}
